export default {
    PAGE_SECTION: 'PAGE_SECTION',
    AVAILABLE_SECTION: 'AVAILABLE_SECTION',
};


// WEBPACK FOOTER //
// ./src/containers/templates/builder/sections/tab_dnd/dnd_types.js